import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { toLocalIsoOrNull } from '../../../../utils/date.utils';

interface DialogData {
  timeOff: any;
  staffName: string;
}

@Component({
    selector: 'app-timeoff-dialog',
    templateUrl: './timeoff-dialog.component.html',
    styleUrls: ['./timeoff-dialog.component.css'],
    standalone: false
})
export class TimeOffDialogComponent implements OnInit {
  timeOffForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<TimeOffDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm(): void {
    this.timeOffForm = this.fb.group({
      startAt: [this.data.timeOff ? this.data.timeOff.startAt : '', Validators.required],
      endAt: [this.data.timeOff ? this.data.timeOff.endAt : '', Validators.required],
      reason: [this.data.timeOff ? this.data.timeOff.reason : '', Validators.maxLength(500)]
    });
  }

  calculateDuration(): string {
    const startAt = this.timeOffForm.get('startAt').value;
    const endAt = this.timeOffForm.get('endAt').value;

    if (!startAt || !endAt) {
      return '';
    }

    const start = new Date(startAt);
    const end = new Date(endAt);
    const diffMs = end.getTime() - start.getTime();
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
      return 'Fecha de fin debe ser posterior a la de inicio';
    }

    if (diffDays === 0) {
      return '1 día';
    }

    return diffDays + ' días';
  }

  onSave(): void {
    if (this.timeOffForm.valid) {
      const formValue = this.timeOffForm.value;
      
      const transformedValue = {
        startAt: this.formatDateTimeToISO(formValue.startAt),
        endAt: this.formatDateTimeToISO(formValue.endAt),
        reason: formValue.reason || null
      };
      
      this.dialogRef.close(transformedValue);
    } else {
      this.markFormGroupTouched(this.timeOffForm);
    }
  }

  private formatDateTimeToISO(value: any): string | null {
    // Hora local de la location, sin 'Z' ni offset.
    return toLocalIsoOrNull(value);
  }

  private markFormGroupTouched(formGroup: UntypedFormGroup): void {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      control.markAsTouched();
    });
  }
}
